/**
 * `maxTracks` (deprecated) desliga o clientTrackSwitchOffControl automático do SDK,
 * que usa IntersectionObserver — em layouts produção o vídeo pode parecer “fora do ecrã”
 * e ficar com frameRate 0 / telemetry track-stalled.
 * @see twilio-video es5/connect.js (maxTracks → clientTrackSwitchOffControl = 'disabled')
 */
export const twilioViewerBandwidthProfile = {
    video: {
        maxTracks: 10,
        maxSubscriptionBitrate: 4000000
    }
};

/** VP8 costuma ser mais previsível entre browsers; bitrate ajuda estabilidade. */
export const twilioPublisherMediaOptions = {
    preferredVideoCodecs: [{ codec: 'VP8' }],
    maxVideoBitrate: 2500000
};
